'use client'

import { MoreHorizontal } from 'lucide-react'
import * as React from 'react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface ThreeDotsProps {
  items: {
    label: string
    onClick: (e?: React.MouseEvent) => void
    icon?: React.ReactNode
    disabled?: boolean
    /** A removal or other irreversible action: rendered in the destructive style. */
    destructive?: boolean
  }[]
  label?: string
  /** The trigger's accessible name, e.g. "Actions for Ayse Yilmaz". Defaults to "Open menu". */
  triggerLabel?: string
}

export function ThreeDots({ items, label, triggerLabel }: ThreeDotsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button variant="ghost" size="icon-sm" />}>
        <span className="sr-only">{triggerLabel ?? 'Open menu'}</span>
        <MoreHorizontal className="h-4 w-4" aria-hidden="true" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {label && <DropdownMenuLabel>{label}</DropdownMenuLabel>}
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <DropdownMenuItem
              variant={item.destructive ? 'destructive' : 'default'}
              onClick={(e) => {
                e.stopPropagation()
                item.onClick(e)
              }}
              disabled={item.disabled}
            >
              {item.icon && <span className="mr-2">{item.icon}</span>}
              {item.label}
            </DropdownMenuItem>
            {index < items.length - 1 && <DropdownMenuSeparator />}
          </React.Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
